import React, { useState, useEffect } from "react";
import { Grid, Button, InputAdornment, IconButton } from "@material-ui/core";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import Alert from "@material-ui/lab/Alert";
import "./login.css";
import { login } from "../../actions/authActions";
import { clearErrors } from "../../actions/errorActions";
import { connect } from "react-redux";
import {
  Visibility,
  VisibilityOff,
  Face,
  Fingerprint,
} from "@material-ui/icons/";
import Loading from "../Loading";

const LoginForm = (props) => {
  const [loginID, setLoginID] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (props.auth.msg === "Login Successfully") {
      props.history.push(`/dashboard/${props.auth.seller._id}`);
    }
    if (props.auth.msg === "Seller is blocked") {
      props.history.push("/seller/blocked");
    }
  }, [props.auth.msg]);

  useEffect(() => {
    if (props.error) {
      setLoading(false);
    }
  }, [props.error]);

  const handleSubmit = () => {
    props.clearErrors();
    const data = {
      loginID: `${loginID}@vb.com`,
      password,
    };
    props.login(data);
  };

  return (
    <div style={{ textAlign: "center" }}>
      <div style={{ display: "flex", marginBottom: "45px" }} className="title">
        <h3 style={{ marginLeft: "30px" }}>Virtual Bazaar</h3>
        <h4 style={{ margin: "25px auto 0 auto" }}>Seller's Dashboard</h4>
      </div>
      <h2 style={{marginBottom:50}}>Login</h2>
      <div>
        <ValidatorForm onSubmit={handleSubmit}>
          <div style={{ marginBottom: "20px " }}>
            <div style={{ display: "inline-flex", marginBottom: "10px" }}>
              <div style={{ margin: "8px 40px 0 0" }}>
                <Face fontSize="large" />
              </div>
              <div className="responsive-input-loginID">
                <TextValidator
                  fullWidth={true}
                  label="Login Id"
                  onChange={(e) => setLoginID(e.target.value)}
                  name="loginID"
                  value={loginID}
                  style={{textTransform:'lowercase'}}
                  variant="outlined"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <p>@vb.com</p>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>
          </div>
          <div style={{ marginBottom: "20px" }}>
            <div style={{ display: "inline-flex", marginBottom: "10px" }}>
              <div style={{ margin: "8px 40px 0 0" }}>
                <Fingerprint fontSize="large" />
              </div>
              <div>
                <TextValidator
                  fullWidth={true}
                  label="Password"
                  onChange={(e) => setPassword(e.target.value)}
                  name="password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  variant="outlined"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>
          </div>
          {props.error && (
            <div className="responsive-alert">
              <Alert severity="error">{props.error}</Alert>
            </div>
          )}
          <Grid container justify="flex-end">
            <a href="/forgot/password">Forgot Password</a>
          </Grid>
          <Grid container justify="center" style={{ marginTop: "30px" }}>
            {!loading ? (
              <Button
                color="primary"
                variant="contained"
                onClick={() => {
                  setLoading(true);
                  handleSubmit();
                }}
                disabled={loginID.length < 4 || password.length < 4 || loading}
              >
                Login
              </Button>
            ) : (
              <Loading />
            )}
          </Grid>
        </ValidatorForm>
        {error}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  error: state.error.error,
});

export default connect(mapStateToProps, { login, clearErrors })(LoginForm);
